import React, { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  Accordion,
  Breadcrumb,
  Button,
  Divider,
  Form,
  Header,
  Icon,
  Segment,
  Select,
} from "semantic-ui-react";
import { MaintenanceContext } from "context/maintenanceProvider";
import { DeviceContext } from "context/deviceProvider";
import LetterLoading from "components/loading/letterLoading";
import Navigation from "components/navigation";
import Sidebar from "components/sidebar";
import "scss/screens/maintenance/newMaintenance.scss";
import Swal from "sweetalert2";
import {
  warrantyOptions,
  warrantyYOptions,
  contactOptions,
  stateOptions,
  unitOfUseOptions,
  problemOptions,
} from "assets/data/maintenanceOptions";
import { UserContext } from "context/userProvider";
import Homepage from "screens/homepage/homepage";
import SemanticDatepicker from "react-semantic-ui-datepickers";
import { Data } from "@react-google-maps/api";

export default function NewMaintenance() {
  const [isLoading, setIsLoading] = useState(false);
  const [activeDetail, setActiveDetail] = useState(0);
  const [activeImage, setActiveImage] = useState(0);
  const [maintenanceImage, setMaintenanceImage] = useState([]);
  const [repairDetail, setRepairDetail] = useState([]);
  const maintenances = useContext(MaintenanceContext);
  const partsList = useContext(DeviceContext);
  const customerList = useContext(UserContext);
  const users = useContext(UserContext);
  const [customerDetail, setCustomerDetail] = useState([]);
  const { id } = useParams();

  const [deviceTypesList, setDeviceTypesList] = useState([]);

  useEffect(() => {
    setIsLoading(true);
    getMaintenance();
    setIsLoading(false);
    // getCustomersData();
    // setTimeout(() => setIsLoading(false), 1000);
  }, []);

  async function getMaintenance() {
    await partsList.getMasterParts({ model: null });
    await customerList.getCustomers({ team_id: -1, role: "" });
  }

  // async function getCustomersData() {
  //   customerList.getCustomers({ team_id: -1, role: "" });

  //   if (customerList.customerList.length > 0) {
  //     const detail = customerList.customerList.filter((user) => user.id === id);
  //     setCustomerDetail(detail[0]);
  //     console.log(customerDetail);
  //     //   await fetchParts(detail[0].partCode);
  //   }

  // }

  const alertDialog = (title, text, icon) => {
    Swal.fire({
      title: title,
      text: text,
      icon: icon,
    });
  };

  const onUpdateTime = (date) => {
    if (date) {
      let updateDate =
        date
          .toLocaleDateString("ko-KR", { year: "numeric", month: "2-digit", day: "2-digit" })
          .replace(/\./g, "-")
          .replace(/\s/g, "")
          .slice(0, -1);
      return updateDate;
    }
    return null; // หรือคืนค่าที่ต้องการให้เหมาะสมในกรณีที่ date เป็น null
  };

  const onAddMaintenanceWithImage = async (button) => {
    if (
      "clpSerial" in repairDetail === false ||
      "fullName" in repairDetail === false ||
      "phoneNo" in repairDetail === false ||
      "problemDetectionDate" in repairDetail === false ||
      "topic" in repairDetail === false ||
      "amountOfUse" in repairDetail === false ||
      "amountOfUseUnit" in repairDetail === false ||
      "state" in repairDetail === false
    ) {
      return alertDialog("Warning!", "กรุณากรอกข้อมูลให้ครบถ้วน", "warning");
    }

    const data = {
      clpSerial: repairDetail?.clpSerial,
      model: repairDetail?.model,
      userId: repairDetail?.userId,
      fullName: repairDetail?.fullName,
      phoneNo: repairDetail?.phoneNo,
      note: repairDetail?.note,
      amountOfUse: repairDetail.amountOfUse,
      amountOfUseUnit: repairDetail.amountOfUseUnit,
      contactChoice: repairDetail?.contactChoice,
      deviceType: repairDetail?.deviceType,
      inWarranty: repairDetail?.isWarranty,
      periodActiveRange: repairDetail?.periodActiveRange,
      problemDetectionDate: repairDetail?.problemDetectionDate,
      partCode: repairDetail?.partCode,
      responsibleBy: users.userDetail?.firstname,
      requestBy: "manager",
      state: button === "approve" ? "processing" : repairDetail?.state,
      topic: repairDetail?.topic,
      workerId: users.userDetail?.firstname,
    };

    console.log("ddsss", data);
    const formData = new FormData();
    maintenanceImage?.map((image) => formData.append("file", image));
    formData.append("data", JSON.stringify(data));

    console.log(data);
    let result = await maintenances.addMaintenanceWithImage(formData);
    if (result?.code === 0) {
      return alertDialog("Success!", result?.description, "success");
    } else {
      return alertDialog("Error!", result?.description, "error");
    }
  };

  const handleClick = (e, titleProps) => {
    const { index } = titleProps;
    if (titleProps.name === "userDetail") {
      const newIndex = activeDetail === index ? -1 : index;
      setActiveDetail(newIndex);
    } else {
      const newIndex = activeImage === index ? -1 : index;
      setActiveImage(newIndex);
    }
  };

  const maintenanceDetail = () => {
    // console.log(partsDetail.name_th);
    // console.log(repairDetail);
    return (
      <Segment>
        <Accordion fluid styled>
          <Accordion.Title
            active={activeDetail === 0}
            index={0}
            name="userDetail"
            onClick={handleClick}
          >
            <Icon name="dropdown" />
            ข้อมูลการแจ้งซ่อม
          </Accordion.Title>
          <Accordion.Content active={activeDetail === 0}>
            {repairUserDetail()}
          </Accordion.Content>
        </Accordion>
        <br />
        <Accordion fluid styled>
          <Accordion.Title
            active={activeImage === -1}
            index={0}
            name="image"
            onClick={handleClick}
          >
            <Icon name="dropdown" />
            ข้อมูลรูปภาพ
          </Accordion.Title>
          <Accordion.Content active={activeImage === -1}>
            {uploadImage()}
          </Accordion.Content>
        </Accordion>
      </Segment>
    );
  };

  const repairUserDetail = () => {
    const partCodeOptions = partsList?.partsList.map((part) => ({
      key: part.code,
      value: part.code,
      text: part.name_th,
    }));

    const getclpSerial = customerList?.customerList?.map((user) => ({
      key: user.clpSerial,
      value: user.clpSerial,
      text: user.clpSerial,
    }));

    const mobileNoOptions = customerList?.customerList.map((user) => ({
      key: user.id,
      value: user.name,
      text: user.phone_no == null ? "-" : user.phone_no,
      userId: user.id,
    }));

    let modelData = customerList?.customerList.filter(
      (user) => user.name === repairDetail?.fullName
    );

    const modelOptions = [];
    if (modelData != null) {
      const uniqueModels = new Set();
      modelData[0]?.deviceTypes?.forEach((device) => {
        if (!uniqueModels.has(device.model)) {
          uniqueModels.add(device.model);
          modelOptions.push({
            key: device.model,
            value: device.model,
            text: device.model,
          });
        }
      });
    }

    return (
      <table>
        <tbody>

        <tr>
            <td>
              <label>
                เบอร์โทรลูกค้า <span style={{ color: "#ff0000" }}>*</span>
              </label>
            </td>
            <td>
              <Form>
                <Form.Field>
                  <Select
                    search
                    options={mobileNoOptions}
                    placeholder="เบอร์โทรลูกค้า"
                    // value={repairDetail?.phoneNo}      
                    onChange={(e, value) => {

                      setDeviceTypesList({
                        ...deviceTypesList,
                        clpSerial: "",
                      })
                                         
                      let selectedOption = value.options.find(option => option.value === value.value);
                      let selectedUser = customerList?.customerList.find(user => user.phone_no === selectedOption.text);

                      setRepairDetail({
                        ...repairDetail,
                        phoneNo: selectedOption.text,
                        fullName: value.value,
                        userId: selectedUser?.id,
                        deviceType: "",
                        periodActiveRange: "",
                        note: "",
                        amountOfUse: "",
                        amountOfUseUnit: "",
                        contactChoice: "",
                        deviceType: "",
                        inWarranty: 2,
                        problemDetectionDate: "",
                        partCode: "",
                        topic: "",
                      });
                    }}
                  />
                </Form.Field>
              </Form>
            </td>
          </tr>

          <tr>
            <td>
              <label>
                ชื่อบัญชีผู้ใช้งาน <span style={{ color: "#ff0000" }}>*</span>
              </label>
            </td>
            <td>
              <Form>
                <Form.Field>
                  <input
                    placeholder="ชื่อ-นามสกุล ผู้ใช้งาน"
                    value={repairDetail?.userId || ""}
                    readOnly
                    onChange={(e) =>
                      setRepairDetail({
                        ...repairDetail,
                        userId: e.target.value,
                      })
                    }
                  />
                </Form.Field>
              </Form>
            </td>
          </tr>

          <tr>
            <td>
              <label>
                ชื่อ-นามสกุล <span style={{ color: "#ff0000" }}>*</span>
              </label>
            </td>
            <td>
              <Form>
                <Form.Field>
                  <input
                    placeholder="ชื่อ-นามสกุล ผู้ใช้งาน"
                    value={repairDetail?.fullName || ""}
                    readOnly
                    onChange={(e) =>
                      setRepairDetail({
                        ...repairDetail,
                        fullName: e.target.value,
                      })
                    }
                  />
                </Form.Field>
              </Form>
            </td>
          </tr>

          <tr>
            <td>
              <label>
                รุ่นเครื่องจักร <span style={{ color: "#ff0000" }}>*</span>
              </label>
            </td>
            <td>
              <Form>
                <Form.Field>
                  <Select
                    search
                    options={modelOptions}
                    placeholder="รุ่นเครื่องจักร"
                    onChange={(e, value) => {
                      let check = value.options.filter((text) => text.value === value.value);
                      let uniqueOptions = value.options.filter((text) => text.value !== value.value);
                      let deviceList = customerList?.customerList?.find((user) => user.id === repairDetail?.userId)
                        ?.deviceTypes.filter((device) => device.model === check[0]?.text);

                      let clpSerialList = deviceList?.map((device) => ({
                        key: device.clpserial,
                        value: device.clpserial,
                        text: device.clpserial,
                      }));

                      let deviceTypeList = deviceList?.map((device) => ({
                        key: device.clpserial,
                        value: device.type,
                        text: device.type,
                      }));

                      let periodActiveRange = deviceList?.map((device) => ({
                        key: device.clpserial,
                        value: device.devicebuydate,
                        text: device.devicebuydate,
                      }));

                      setRepairDetail({
                        ...repairDetail,
                        model: check[0]?.text,
                        options: uniqueOptions,
                      })

                      setDeviceTypesList({
                        ...deviceTypesList,
                        clpSerial: clpSerialList,
                        deviceType: deviceTypeList,
                        devicebuydate: periodActiveRange,
                      })
                    }}
                  />
                </Form.Field>
              </Form>
            </td>
          </tr>

          <tr>
            <td>
              <label>
                หมายเลขเครื่องจักร <span style={{ color: "#ff0000" }}>*</span>
              </label>
            </td>
            <td>
              <Form>
                <Form.Field>
                  <Select
                    search
                    options={deviceTypesList?.clpSerial}
                    placeholder="หมายเลขเครื่องจักร"
                    onChange={(e, value) => {
                      let check = value.options.filter((text) => text.value === value.value);
                      let deviceType = deviceTypesList?.deviceType.filter((text) => text.key === check[0]?.text);
                      let devicebuydate = deviceTypesList?.devicebuydate.filter((text) => text.key === check[0]?.text);
                      
                      let dateOnly = devicebuydate[0]?.value.split(" ")[0];
                      const dateParts = dateOnly.split("-");
                      const formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
                      
                      console.log("formattedDate",formattedDate)
                      setRepairDetail({
                        ...repairDetail,
                        clpSerial: check[0]?.text,
                        deviceType: deviceType[0]?.text,
                        periodActiveRange: formattedDate,
                      });
                    }}
                  />
                </Form.Field>
              </Form>
            </td>
          </tr>

          <tr>
            <td>
              <label>
                ประเภทเครื่องจักร
              </label>
            </td>
            <td>
              <Form>
                <Form.Field>
                  <input
                    placeholder="ประเภทเครื่องจักร"
                    value={repairDetail?.deviceType || ""}
                    readOnly
                    onChange={(e) =>
                      setRepairDetail({
                        ...repairDetail,
                        deviceType: e.target.value,
                      })
                    }
                  />
                </Form.Field>
              </Form>
            </td>
          </tr>
    
          <tr>
            <td>
              <label>
                วันที่เริ่มใช้งาน
              </label>
            </td>
            <td>
              <Form>
                <Form.Field>
                  <input
                    placeholder="วันที่เริ่มใช้งาน"
                    value={repairDetail?.periodActiveRange || ""}
                    format="DD-MM-YYYY"
                    readOnly
                    onChange={(e, { value }) => 
                      setRepairDetail({
                        ...repairDetail,
                        periodActiveRange: value,
                      })
                    }
                  />
                </Form.Field>
              </Form>      
            </td>
          </tr>

          <tr>
            <td>
              <label>
                ระยะเวลาประกัน <span style={{ color: "#ff0000" }}>*</span>
              </label>
            </td>
            <td>
              <Form>
                <Select
                  options={warrantyYOptions}
                  placeholder="ระยะเวลาประกัน"
                  onChange={(e, { value }) => {
                    // คำนวณวันที่จากวันที่ปัจจุบันและระยะเวลาประกัน
                    const currentDate = new Date();

                    const dateParts = repairDetail?.periodActiveRange.split("-"); // แยกส่วนของวัน เดือน และปี
                    const day = dateParts[0];
                    const month = dateParts[1];
                    const year = dateParts[2];

                    // สร้างวันที่ในรูปแบบ JavaScript
                    const formattedDate = new Date(`${year}-${month}-${day}`);
                    const startDate = new Date(formattedDate);

                    // แปลงเป็น timestamp ของวันที่เริ่มใช้งานและวันที่ปัจจุบัน
                    const startTimestamp = startDate.getTime();
                    const currentTimestamp = currentDate.getTime();

                    // คำนวณจำนวนวันที่ผ่านไป
                    const daysPassed = Math.floor((currentTimestamp - startTimestamp) / (1000 * 60 * 60 * 24));

                    // ตรวจสอบว่าวันที่ใหม่เกินระยะเวลาประกันหรือไม่
                    // ถ้าเกินให้ไม่อยู่ในการรับประกัน (isWarranty = 0)
                    // ถ้าไม่เกินให้เป็น อยู่ในการรับประกัน (isWarranty = 1)
                    const isWarranty = daysPassed <= value ? 1 : 0;

                    setRepairDetail({
                      ...repairDetail,
                      isWarranty: isWarranty,
                    })
                  }}
                />
              </Form>
            </td>
          </tr>

          <tr>
            <td>
              <label>
                สถานะการรับประกัน <span style={{ color: "#ff0000" }}>*</span>
              </label>
            </td>
            <td>
              <Form>
                <Select
                  options={warrantyOptions}
                  placeholder="สถานะการรับประกัน"
                  value={repairDetail?.isWarranty}
                  readOnly
                  onChange={(e, { value }) =>
                    setRepairDetail({
                      ...repairDetail,
                      isWarranty: value,
                    })
                  }
                />
              </Form>
            </td>
          </tr>

          <tr>
            <td>
              <label>
                ปัญหาแจ้งซ่อม <span style={{ color: "#ff0000" }}>*</span>
              </label>
            </td>
            <td>
              <Form>
                <Form.Field>
                  <Select
                    options={problemOptions}
                    placeholder="ปัญหาแจ้งซ่อม"
                    value={repairDetail?.topic}
                    onChange={(e, { value }) =>
                      setRepairDetail({
                        ...repairDetail,
                        topic: value,
                      })
                    }
                  />
                </Form.Field>
              </Form>
            </td>
          </tr>

          <tr>
            <td>
              <label>
                วันที่พบปัญหา <span style={{ color: "#ff0000" }}>*</span>
              </label>
            </td>
            <td>
              <Form>
                <Form.Field>
                  <SemanticDatepicker
                    placeholder="วันที่พบปัญหา"
                    format="DD-MM-YYYY"
                    onChange={(e, { value }) =>
                      setRepairDetail({
                        ...repairDetail,
                        problemDetectionDate: onUpdateTime(value),
                      })
                    }
                  />
                </Form.Field>
              </Form>
            </td>
          </tr>
          <tr>
            <td>
              <label>วิธีการติดต่อ</label>
            </td>
            <td>
              <Form>
                <Form.Group inline>
                  <Select
                    options={contactOptions}
                    placeholder="วิธีการติดต่อ"
                    value={repairDetail?.contactChoice}
                    onChange={(e, { value }) =>
                      setRepairDetail({
                        ...repairDetail,
                        contactChoice: value,
                      })
                    }
                  />

                  &emsp;
                  <tr>
                    <td>
                      <label>ผู้รับเรื่อง</label>
                    </td>
                  </tr>
                  <input
                    placeholder="ผู้รับเรื่อง"
                    value={repairDetail?.responsibleBy || users.userDetail?.firstname}
                    readOnly
                    onChange={(e, { value }) =>
                      setRepairDetail({
                        ...repairDetail,
                        workerId: value,
                        responsibleBy: value,
                      })
                    }
                  />
                </Form.Group>
              </Form>
            </td>
          </tr>

          <tr>
            <td>
              <label>แจ้งซ่อมอะไหล่</label>
            </td>
            <td>
              <Form>
                <Form.Field>
                  <Select
                    search
                    options={partCodeOptions}
                    placeholder="แจ้งซ่อมอะไหล่"
                    value={repairDetail?.partCode}
                    onChange={(e, { value }) =>
                      setRepairDetail({
                        ...repairDetail,
                        partCode: value,
                      })
                    }
                  />
                </Form.Field>
              </Form>
            </td>
          </tr>


          <tr>
            <td>
              <label>
                ปริมาณการใช้งาน <span style={{ color: "#ff0000" }}>*</span>
              </label>
            </td>
            <td>
              <Form>
                <Form.Group inline>
                  <input
                    placeholder="ปริมาณการใช้งาน"
                    value={repairDetail?.amountOfUse || ""}
                    onChange={(e) =>
                      setRepairDetail({
                        ...repairDetail,
                        amountOfUse: e.target.value,
                        amountOfUseUnit: "กก./วัน",
                      })
                    }
                    style={{ width: "50%" }}
                  />
                  &emsp;
                  {/* <Select
                    options={unitOfUseOptions}
                    placeholder="ระบุหน่วยการใช้งาน"
                    value={repairDetail?.amountOfUseUnit}
                    onChange={(e, { value }) =>
                      setRepairDetail({
                        ...repairDetail,
                        amountOfUseUnit: value,
                      })
                    }
                  /> */}
                  <label>กก./วัน</label>
                </Form.Group>
              </Form>
            </td>
          </tr>
          <tr>
            <td>
              <label>
                สถานะดำเนินการ <span style={{ color: "#ff0000" }}>*</span>
              </label>
            </td>
            <td>
              <Form>
                <Form.Field>
                  <Select
                    options={stateOptions}
                    placeholder="สถานะดำเนินการ"
                    value={repairDetail?.state}
                    onChange={(e, { value }) =>
                      setRepairDetail({
                        ...repairDetail,
                        state: value,
                      })
                    }
                  />
                  {repairDetail?.state === "later" && (
                    <div className="calendar">
                      <SemanticDatepicker
                        onChange={(e, { value }) =>
                          setRepairDetail({
                            ...repairDetail,
                            appointmentDate: value,
                          })
                        }
                      />
                    </div>
                  )}
                </Form.Field>
              </Form>
            </td>
          </tr>
          <tr>
            <td>
              <label>หมายเหตุ</label>
            </td>
            <td>
              <Form>
                <Form.Field>
                  <textarea
                    placeholder="ระบุวัตถุดิบ เช่น พันธุ์ข้าว, ชนิดไม้, ชนิดดิน, ลักษณะแม่น้ำ เป็นต้น"
                    value={repairDetail?.note}
                    onChange={(e) =>
                      setRepairDetail({
                        ...repairDetail,
                        note: e.target.value,
                      })
                    }
                  />
                </Form.Field>
              </Form>
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  const onSelectImage = (e) => {
    if (maintenanceImage.length < 5 && e.target.files.length < 6) {
      let files = Array.from(e.target.files).map((image) => image);
      setMaintenanceImage([...maintenanceImage, ...files]);
    } else {
      alertDialog("Error!", "ไม่สามารถอัพโหลดรูปภาพได้เกิน 5 รูป", "error");
    }
  };

  const removeImage = (name) => {
    const imageFilter = maintenanceImage.filter((image) => image.name !== name);
    setMaintenanceImage(imageFilter);
  };

  const uploadImage = () => {
    // console.log(maintenanceImage);
    return (
      <Segment>
        <Divider horizontal>
          <Header as="h4">
            <Icon name="images" />
            แจ้งซ่อม {maintenanceImage.length}/5
          </Header>
        </Divider>

        <input type="file" multiple onChange={onSelectImage} />
        <div className="addMaintenance">
          {maintenanceImage.length > 0 &&
            maintenanceImage.map((image, idx) => (
              <div key={idx} className="fadein">
                <div onClick={() => removeImage(image.name)} className="delete">
                  <Icon name="times circle" size="large" />
                </div>
                <img
                  key={idx}
                  alt="add-maintenance"
                  src={URL.createObjectURL(image)}
                  style={{
                    width: 300,
                    height: 300,
                    objectFit: "cover",
                  }}
                />
              </div>
            ))}
        </div>
      </Segment>
    );
  };

  const createButton = () => {
    return (
      <>
        <Button color="blue" onClick={() => onAddMaintenanceWithImage("save")}>
          บันทึก
        </Button>
        &emsp;
        {users.userDetail?.role === "manager" && (
          <Button
            color="green"
            onClick={() => onAddMaintenanceWithImage("approve")}
          >
            อนุมัติ
          </Button>
        )}
      </>
    );
  };

  const sections = [
    { key: "หน้าแรก", content: "หน้าแรก", link: true, href: "/home" },
    {
      key: "แจ้งซ่อม",
      content: "แจ้งซ่อม",
      link: true,
      href: "/maintenance-list",
    },
    {
      key: "เพิ่มการแจ้งซ่อม",
      content: "เพิ่มการแจ้งซ่อม",
      active: true,
    },
  ];

  return (
    <div className="newMaintenance">
      <LetterLoading isOpen={isLoading} />
      <Sidebar tabActive="maintenanceInform" />
      <Navigation />

      <div className="newMaintenance-content">
        <div className="newMaintenance-content-header">
          <h2>แจ้งซ่อม</h2>
        </div>
        <hr />
        {/* {breadcrumbLink()} */}
        <Breadcrumb icon="right angle" sections={sections} />
        <div className="newMaintenance-content-detail">
          {maintenanceDetail()}
        </div>
        <div className="newMaintenance-content-button">{createButton()}</div>
      </div>
    </div>
  );
}
